import {Component, OnInit} from '@angular/core';
import {AuthService} from 'common-domain';

@Component({
  selector: 'app-change-expired-password',
  templateUrl: './change-expired-password.component.html',
  styleUrls: ['./change-expired-password.component.scss']
})
export class ChangeExpiredPasswordComponent implements OnInit {

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
  }

  passwordChanged(changed: boolean) {
    if (changed) {
      this.authService.logout('Password Changed Successfully', true);
    } else {
      this.authService.logout('Password change cancelled', false);
    }
  }
}
